const $ = require('jquery');
const _ = require("underscore");
const modalHtml = require("../../sharedHtml/modal.html");
const targetSelector = "#location-facilities-lookup";

//for table data. filters,saved views
import { dataTableFilterData } from "../../components/lookupTable/stores/testFilterData.js";
import { testColumns } from "../../components/lookupTable/stores/testColumnModalData.js";
import { testSavedViews, testNewSavedView } from "../../components/lookupTable/stores/savedViews.js";
const sharedModalHtml = require("../../sharedHtml/modal.html");
import run from '../../utilities/run';
import render from "../../utilities/render";
import LookupTable from "../../components/lookupTable/index";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, SUCCESS_MODAL_TIMEOUT } from "../../constants";
import { searchDropdown } from "./filter/searchDropdown.js";
import { buildExport, prepareDataToSendController, isEdit, readSpecificObjectFromCurrentData, doAjax, readSpecificKeyFromSearchCriteria, alterSearchCriteriForController, pushFilterSessionCacheState, retriveCriteriaObjectByOperation, isNew, isDeleteView, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
import { actionOptions } from "./filter/actionOptions.js";
import { handleCustomDropdownEvents } from "../../utilities/customBootstrapDropdowns";
import { isPresent, keyDefaultFalseOption, isTruthy } from '../../utilities/general';

let actionList = actionOptions;
let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');
let statusPillRenderTemplate = require("./html/statusPillsTemplate.html");

let pillStatusClasses = {
  "N": "q-pill-blue-border",
  "null": "q-pill-blue-border",// Has to be removed later
  "Y": "q-pill-blue"
}

run(targetSelector, (mainEl) => {
  const dataTableComponentData = mainEl.data("supplychain-lookup");
  const portletNamespace = mainEl.data("portlet-namespace");
  const filterLocationUrl = mainEl.data("location-filter-url");
  //For the search drop down in lookup need to get the filter Criteria from Server
  const shouldCheckCache = mainEl.data("should-check-cache");
  const criteriaObjectFromServer = mainEl.data("filter-criteria-from-server");
  //For the views - add/save/delete
  let selectFromOrgModal;
  const savedViews = mainEl.data("facility-saved-view");
  const pageReloadUrl = mainEl.data("reload-url");
  const saveViewURL = mainEl.data("save-view-url");
  const deleteViewURL = mainEl.data("delete-view-url");
  const exportUrl = mainEl.data("export-url");
  const splExportUrl = mainEl.data("spl-export-url");
  const deleteActionUrl = mainEl.data("delete-action-url");
  const newMappingUrl = mainEl.data("new-mapping-url");
  const returnTypes = mainEl.data("return-types-dropdown");
  const classificationArray = mainEl.data("classification-dropdown");
  const states = mainEl.data("states-dropdown");
  const cmrAddresses = mainEl.data("ship-addresses-dropdown");
  const bulkDeleteMappings = mainEl.data("bulk-delete-url");
  const displayColumns = mainEl.data("display-columns");
  const userInfo = mainEl.data("user-info");
  const changeStatusURL = mainEl.data("change-status");
  const editFacilityUrl = mainEl.data("edit-url");
  const supplyChainConfig = mainEl.data("supply-chain-config");
  const viewfacilityRenderUrl = mainEl.data("view-detail-url");
  const viewSplfacilityRenderUrl = mainEl.data("view-spl-detail-url");
  const pageRefreshUrl = mainEl.data("page-refresh-url");
  const changeStatusBulkURL = mainEl.data("change-status-bulk");
  const supplyChainConfigURL = mainEl.data("supply-chain-config-url");
  const orderProcessGuideURL = mainEl.data("order-proccess-guide-url");
  const inboundClassifcaionlist = mainEl.data("inbound-classfications");
  const defaultFacTypeRms = mainEl.data("default-facilty-Types-rms");
  const facilityTypeJson = mainEl.data("facility-types-json");
  const facilityTypeJsonRms = mainEl.data("facility-types-json-rms");
  const facilityTypeJsonHc = mainEl.data("facility-types-json-hc");
  const facilityTypeJsonHcRms = mainEl.data("facility-types-json-hc-rms");
  let tabName = mainEl.data("intial-tab-name");
  const orgList = mainEl.data("org-list-url");
  const orgStatus = mainEl.data("org-status-url");
  const isAddPermission = mainEl.data("add-permission");
  const isEditPermission = mainEl.data("edit-permission");
  const facilitiesUomConfig = mainEl.data("facilities-uom-config");
  const isSplUser = mainEl.data("is-spl-user");
  const retailerFedexAccounts = mainEl.data("retailer-fedex-accounts");


  let targetObject = "";
  let selectedRows = "";
  let rsaId = "";
  let rsaIdDelete = "";
  let loadDropDowns = "";
  let organizationActiveCheckErrorModal;
  let exportModal = new buildExport();
  let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  generateOrganizationActiveCheckErrorModals();

  $(".save-mapping-btn").on('click', onSaveMappingClick);
  function onSaveMappingClick(e) {
    newLocationModal.modal('hide');
    submitModalFlow.showLoadingModal();
    e.preventDefault();
    $.ajax({
      url: newMappingUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        rsaId: rsaId,
        rsaType: $('#returnType').val(),
        rsaState: $('#originalState').val(),
        rsaShipToAddressId: $('#shipToAddress').val(),
        rsaInboundClassification: $('#inboundClassification').val()
      },
      success: function (data) {
        if (data.response == "success") {
          submitModalFlow.showSuccessModal();
          setTimeout(function () {
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }
        if (data.response == "error") {
          submitModalFlow.hideAllModals();
          newLocationModal.modal('show');
          $(".show-on-error").show();
        }

      }
    });
  }

  function getIndexValue() {
    if (userInfo == "HONEYCOMB_RMS") {
      return 1;
    } else {
      return 0;
    }
  }

  if (shouldCheckCache) {
    targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
  }

  let facilityMappingLookup = new LookupTable({
    // REQUIRED - Set a target element
    target: $("#lookup-facilities-wrapper"),
    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
    minWidthClass: "q-min-width-sm-til-md",
    // REQUIRED - Set which data should be visible for mobile
    mobileColumns: [
      {
        data: "cadLocationName",
        title: "Facility Name",
        render: createDetailLink,
      },
      {
        data: "cadActive",
        title: "Status",
        render: statusPillRender
      }
    ],
    tableSearchInput: {
      value: (targetObject != "" ? targetObject.value[0] : "")
    },
    tableSearchDropdown: {
      selected: (targetObject == "" ? "" : targetObject.key),
      columns: searchDropdown
    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    //tableSearchDropdown: true,
    //savedViews: savedViews,
    savedViews: savedViews,
    newSavedViews: (dataTableComponentData.newSavedViews !== undefined ? dataTableComponentData.newSavedViews : ""),
    newViewIndexOverride: getIndexValue(),
    bulkSelect: false,
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      // scrollX: true, // Added scroll feature - HB-11056 - table header not working after adding this - check with Mike
      data: dataTableComponentData.content,
      columnDefs: [{ className: "custom-class", targets: [1] },
      ],
      order: [
        [8, 'desc']
      ],
      columns: [
        {
          data: "cadId",
          title: "Actions",
          render: renderActionWrap,
          orderable: false,
          class: 'dtc-action-column'
        },
        {
          data: "cadLocationName",
          title: "Facility Name",
          render: createDetailLink,
          class: 'dtc-min-width-md'
        },
        {
          data: "facilities.facBuildingType",
          title: "Building Type",
          orderable: false,
          class: 'dtc-min-width-sm'
        },
        {
          data: "cmrAddressAttributes",
          title: "Facility Uses",
          render: renderInboundClassificationSp,
          orderable: false,
          class: 'dtc-min-width-lg'
        },
        {
          data: "cadOrganizationName",
          title: "Organization Name",
          class: 'dtc-min-width-md'
        },
        {
          data: "cadAddressId",
          title: "Facility ID",
          orderable: false,
          class: 'dtc-min-width-sm'
        },
        {
          data: "cmrAddressAttributes",
          title: "Facility Type",
          render: renderInboundClassificationSp,
          orderable: false,
          class: 'dtc-min-width-lg'
        },
        {
          data: "cadActive",
          title: "Status",
          render: statusPillRender,
          class: 'dtc-min-width-sm'
        },
        {
          data: "cadContactName",
          title: "Contact Name",
          orderable: false,
          class: 'dtc-min-width-md'
        },
        {
          data: "cadContactPhone",
          title: "Contact Phone",
          orderable: false,
          class: 'dtc-min-width-sm'
        },
        {
          data: "cadContactEmail",
          title: "Contact Email",
          orderable: false,
          class: 'dtc-min-width-md'
        },
        {
          data: "cadAddress1",
          title: "Address",
          orderable: false,
          class: 'dtc-min-width-md'
        },
        {
          data: "cadCity",
          title: "City",
          orderable: false,
          class: 'dtc-min-width-sm'
        },
        {
          data: "cadState",
          title: "State",
          orderable: false,
          class: 'dtc-min-width-sm'
        },
        {
          data: "cadZipcode",
          title: "Postal Code",
          orderable: false,
          class: 'dtc-min-width-sm'
        },
        {
          data: "cadCountry",
          title: "Country",
          orderable: false,
          class: 'dtc-min-width-md'
        },
        {
          data: "cadCreatedDate",
          "visible": false
        }
      ]
    },
    paginationData: dataTableComponentData.page,
    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Facilities",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "facilities"
    },
    onBulkSelectChange: function () {
      selectedRows = facilityMappingLookup.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');
      }
    },

    onFetch: function () {
      let currentData = facilityMappingLookup.generateData();
      tabName = currentData.savedViewTitle;
      facilityMappingLookup.showLoadingOverlay();

      handleToggleLookupSearchField(currentData.savedViewTitle);

      if (isOnlyLookupDataUpdate(currentData)) {
        setTimeout(() => {
          doAjax({ url: filterLocationUrl, success: filterSuccessFun, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isNew(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isEdit(currentData)) {
        setTimeout(() => {
          doAjax({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isDeleteView(currentData)) {
        setTimeout(() => {
          doAjax({ url: deleteViewURL, success: deleteViewSuccessFun, error: errorFun, data: prepareDataToSendController(currentData) });
        }, SUCCESS_MODAL_TIMEOUT);
      }
    }
  });

  function getCurrentActiveTab() {
    return _(savedViews).findWhere({ active: true });
  }

  function handleToggleLookupSearchField(tabTitle) {
    if (tabTitle && tabTitle != "Supply Chain") {
      mainEl.find("#exportData").show();
      showLookupSearchField();
    } else {
      if (isSplUser) {
        mainEl.find("#exportData").show();
      } else {
        mainEl.find("#exportData").hide();
      }
      hideLookupSearchField();
    }
  }

  function showLookupSearchField() {
    mainEl.find(".table-top").show();
  }

  function hideLookupSearchField() {
    mainEl.find(".table-top").hide();
  }

  // for the bulk select
  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    // Changes for Supply Chain Config dropdown - Start
    for (let i = 0; i < savedViews.length; i++) {
      if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab" && !isSplUser) {
        statusTarget = actionList["supplyTab"];
      } else if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab" && isSplUser) {
        statusTarget = actionList["splSupplyTab"];
      } else if (savedViews[i].active == true && savedViews[i].tabtype == "FaciilitiesTab") {
        statusTarget = actionList["actions"];
      }
    }    // Changes for Supply Chain Config dropdown - End

    newRender = render(
      actionCellDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row),
        index: meta.row
      }
    );
    return newRender;
  }

  function renderActionHeaderWrap() {
    //let statusTarget = actionList['all'];

    let statusTarget = actionList["all"];
    for (let i = 0; i < savedViews.length; i++) {
      if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab") {
        statusTarget = actionList["all-supplyTab"];
        break;
      }
    }

    let newRender;
    let data = "";
    let row = "";
    let col = "";
    newRender = render(
      actionHeaderDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row, col)
      }
    );
    return newRender;
  }

  function createDetailLink(data, type, row) {
    let returnString = "";
    let tabType = "";
    for (let i = 0; i < savedViews.length; i++) {
      if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab") {
        tabType = savedViews[i].tabtype;
      } else {
        tabType = savedViews[i].tabtype;
      }
    }
    let html = `<div class="q-marg-all-xs-at-md"><a href={%= viewfacilityRenderUrl %}&{%- portletNamespace%}cadId={%- cadId %} class='details-control anchor-text'>{%- facName %}</a></div>`;
    let splhtml = `<div class="q-marg-all-xs-at-md"><a href={%= viewfacilityRenderUrl %}&{%- portletNamespace%}facilityId={%- cadId %} class='details-control anchor-text'>{%- facName %}</a></div>`;
    if (isTruthy(isSplUser)) {
      returnString = render(
        splhtml, {
          data: data,
          facName: data,
          cadId: row.cadFacId,
          portletNamespace: portletNamespace,
          viewfacilityRenderUrl: viewSplfacilityRenderUrl
        }
      );
    } else {
      returnString = render(
        html, {
          data: data,
          facName: data,
          cadId: row.cadId,
          portletNamespace: portletNamespace,
          viewfacilityRenderUrl: viewfacilityRenderUrl
        }
      );
    }

    return returnString;
  }


  function renderActionCellList(list, data, row, col) {
    let renderedList;
    renderedList = _(list).map((item) => {
      return render(
        actionCellDropdownItemTemplate, {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled: checkDisableForGivenAction(data, row, item.title)
        }
      );
    });
    return renderedList.join('');
  }

  function checkDisableForGivenAction(data, row, actionName) {
    let isSupplyChainTab = false;
    for (let i = 0; i < savedViews.length; i++) {
      if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab" && !isSplUser) {
        isSupplyChainTab = true;
        break;
      }
    }

    if (isRowLevelActionCheck(data)) {
      if (isEditPermission && !isSplUser) {
        return false;
      } else if (isSplUser) {
        return true;
      } else {
        return true;
      }
    } else {
      if (isSupplyChainTab) {
        return true;
      } else {
        let allMatch = true;
        let firstStatus;
        _(selectedRows).map((item) => {
          if (firstStatus && firstStatus !== item.data.cadActive) {
            allMatch = false;
          } else {
            firstStatus = item.data.cadActive;
          }
        });
        return !allMatch;
      }
    }
  }

  function isRowLevelActionCheck(data) {
    return isPresent(data);
  }

  //for the bulk select end

  //Methods used for the Filter and Success
  function filterSuccessFun(data) {
    let shipToAddresses = data.content;
    let page = data.page;
    facilityMappingLookup.setNewData(shipToAddresses);
    facilityMappingLookup.setPaginationData(page);
    pushFilterSessionCacheState();
    facilityMappingLookup.hideLoadingOverlay();
    setExportData(facilityMappingLookup.generateData());
  }

  function savedViewSuccess(data) {
    let shipToAddresses = data.lookupOrgJSON.content;
    let page = data.lookupOrgJSON.page;
    facilityMappingLookup.setNewData(shipToAddresses);
    facilityMappingLookup.setPaginationData(page);
    facilityMappingLookup.setNewSavedViewData(data.savedView, "newSavedView");
    pushFilterSessionCacheState();
    facilityMappingLookup.hideLoadingOverlay();
    setExportData(facilityMappingLookup.generateData());
  }


  function savedEditViewSuccess(data) {
    let shipToAddresses = data.lookupOrgJSON.content;
    let page = data.lookupOrgJSON.page;
    facilityMappingLookup.setNewData(shipToAddresses);
    facilityMappingLookup.setPaginationData(page);
    facilityMappingLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    pushFilterSessionCacheState();
    facilityMappingLookup.hideLoadingOverlay();
    setExportData(facilityMappingLookup.generateData());
  }


  function deleteViewSuccessFun(data) {
    let shipToAddresses = data.lookupOrgJSON.content;
    let page = data.lookupOrgJSON.page;
    facilityMappingLookup.removeSavedView(data.target);
    facilityMappingLookup.setNewData(shipToAddresses);
    facilityMappingLookup.setPaginationData(page);
    facilityMappingLookup.hideLoadingOverlay();
    setExportData(facilityMappingLookup.generateData());
  }

  function errorFun() {
    //facilityMappingLookup.hideLoadingOverlay();
    window.location.reload(true);
  }
  facilityMappingLookup.init();

  const currentTab = getCurrentActiveTab();
  if (currentTab) {
    handleToggleLookupSearchField(currentTab.title);
  }

  //Method used for rendering the whole Inbound classification Text
  /*function renderInboundClassification(row) {
    return render("<span>{%- inboundClassificationText %} </span>", {
      inboundClassificationText: fetchInboundText(classificationArray, row)
    });
  }

  function fetchInboundText(classificationArray, row) {
    const searchInbound = _.find(classificationArray, function (object) {
      return (object.cdmValue == row);
    });
    return (searchInbound != null ? searchInbound.cdmMeaning : "");
  }*/

  function renderInboundClassificationSp(row) {
    const facilityTypeArray = _(row).map(facilityTypeArrayTempSp);
    let facilityTypeArrayResponse;
    facilityTypeArrayResponse = _.filter(facilityTypeArray, (entry => entry && entry.trim() != ''));
    return facilityTypeArrayResponse.join(", ");
  }

  // HB-11056 - Merge Fulfillment Uses and Return Uses into one column - Facility Uses
  function facilityTypeArrayTempSp(row) {
    let data = row;
    if (data.caaValue != null) {
      let facData = facilityTypeJson;
      let facHcRmsData = facilityTypeJsonHcRms;
      let returnValue = '';
      switch (data.caaKey) {
        case 'standard_platform':
          for (let i = 0; facData != null && i < facData.length; i++) {
            if (data.caaValue != '' && facData[i].cdmValue == data.caaValue) {
              returnValue = facData[i].cdmMeaning;
            }
          }
        case 'fulfillment':
          for (let i = 0; facData != null && i < facData.length; i++) {
            if (data.caaValue != '' && facData[i].cdmValue == data.caaValue) {
              returnValue = facData[i].cdmMeaning;
            }
          }
          break;
        default:
          for (let i = 0; facHcRmsData != null && i < facHcRmsData.length; i++) {
            if (data.caaKey != '' && facHcRmsData[i].cdmMeaning == data.caaKey) {
              returnValue = facHcRmsData[i].cdmValue;
            }
          }
      }
      return returnValue;
    }
  }


  function facilityTypeArrayTempRC(data, facilityUse) {
    if (data.caaValue != null) {
      let facData = facilityTypeJson;
      let facInData = facilityTypeJsonRms;
      let returnValue = '';
      let facHcData = facilityTypeJsonHc;
      if (userInfo == "HONEYCOMB_RMS") {
        for (let i = 0; i < facData.length; i++) {
          if (data.caaValue != '' && data.caaKey == 'return' && facData[i].cdmValue == data.caaValue) {
            returnValue = facData[i].cdmMeaning;
          }
        }
      } else {
        for (let i = 0; i < facInData.length; i++) {
          if (data.caaValue == "true" && facInData[i].cdmMeaning == data.caaKey) {
            returnValue = facInData[i].cdmValue;
          }

        }

        for (let i = 0; i < facHcData.length; i++) {
          if (data.caaKey != '' && facHcData[i].cdmMeaning == data.caaKey) {
            returnValue = facHcData[i].cdmValue;
          }
        }
      }

      return returnValue;
    }

  }

  function renderCityAndState(data, type, row) {
    let cityAndStateHTML = `<span>{%- cityAndStateText %}</span>`;

    let cityAndStateHtnlRender = render(
      cityAndStateHTML, {
        cityAndStateText: row.cadCity + "," + row.cadState
      }
    );
    return cityAndStateHtnlRender;
  }


  //Render pill
  function statusPillRender(data, type, row) {
    let newRender;
    let pillClass = pillStatusClasses[data];
    if (data == "Y") {
      data = "Active";
    } else {
      data = "Inactive";
    }
    return newRender = render(
      statusPillRenderTemplate, {
        data,
        pillClass
      }
    );
  }

  // Export component integration.
  function initExport() {
    let exportObj = {
      title: mainEl.data("export-popup-title"),
      exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
      exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
      exportMaxLimitLang: mainEl.data("export-max-row-limit")
    };
    exportModal.init(exportObj);
    exportModal.bindExportEvent();
  }

  function setExportData(currentData) {
    if (isSplUser) {
      exportModal.buildExportBasicURL(splExportUrl, currentData);
    } else {
      exportModal.buildExportBasicURL(exportUrl, currentData);
    }

    exportModal.setExportCount(currentData.totalElements);
  }
  initExport();
  setExportData(facilityMappingLookup.generateData());

  handleCustomDropdownEvents();

  $('body').on('click', '.edit-location', function (e) {
    e.preventDefault();
    if (shallAllowClick(this)) {
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      let location = row.data();
      let cadId = `${location.cadId}`;
      editFacilityCall(cadId);
    }
  });

  function editFacilityCall(cadId) {
    location.href = editFacilityUrl + "&cadId=" + cadId;
  }

  $('body').on('click', '.bulk-activate-rule', function (e) {
    e.preventDefault();
    if (!$(this).hasClass("disabled")) {
      deactivateFacilitiesBulkCall(getAllSelectedOrgIds());
    }
  });

  function getAllSelectedOrgIds() {
    let cadIds = [];
    _(selectedRows).map((item) => {
      let obj = {};
      obj.cadId = item.data.cadId;
      cadIds.push(obj);
    });
    return JSON.stringify(cadIds);
  }

  $('body').on('click', '.activate-rule', function (e) {
    if (shallAllowClick(this)) {
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      let facilities = row.data();
      let cadId = `${facilities.cadId}`;
      let cadActive = `${facilities.cadActive}`
      let cadOrganization = `${facilities.cadOrganizationName}`;
      deactivateFacilitiesCall(cadId, cadActive, cadOrganization);
    }
  });

  function deactivateFacilitiesCall(cadId, cadActive, cadOrganization) {
    let currentData = facilityMappingLookup.generateData();
    let confirmModalBtnText = "Activate Facility";
    let confirmModalTitle = "Activate Facility";
    if (cadActive == 'Y') {
      confirmModalBtnText = "Deactivate Facility";
      confirmModalTitle = "Deactivate Facility";
    }

    if ("null" !== cadOrganization) {
      validateOrgStatus(cadOrganization, confirmModalTitle, confirmModalBtnText, cadId);
    } else {
      changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId);
    }
  }

  function validateOrgStatus(cadOrganization, confirmModalTitle, confirmModalBtnText, cadId) {
    let orgStatus;
    for (let i = 0; i < orgList.length; i++) {
      if (orgList[i].orgName === cadOrganization) {
        orgStatus = orgList[i].orgActive;
      }
    }
    if (orgStatus && !(_(orgStatus).isString())) {
      changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId);
    } else {
      showOrganizationActiveErrorModal();
    }
  }
  //end

  function changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId) {
    let deactivateFacilityModal = new SubmitModalFlow({
      confirmModalTitle: confirmModalTitle,
      confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
      confirmModalBtnText: confirmModalTitle,
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        deactivateFacilityModal.showLoadingModal();
        deactivateFacility({ url: changeStatusURL, success: deactivateSuccess, error: deactivateFailure });
        function deactivateFacility({ url, success, error }) {
          $.ajax({
            url: url,
            data: {
              cadIds: cadId
            },
            dataType: "JSON",
            type: 'POST',
            success: success,
            error: error
          });
        }
        function deactivateSuccess() {
          deactivateFacilityModal.showSuccessModal();
          setTimeout(function () {
            location.reload();
          }, 3000);
        }
        function deactivateFailure() {
          setTimeout(function () {
            deactivateFacilityModal.hideAllModals();
          }, 6000);
        }
      }
    });
    deactivateFacilityModal.init();
    deactivateFacilityModal.showConfirmModal();
  }

  function deactivateFacilitiesBulkCall(cadId) {
    let deactivateFacilityModal = new SubmitModalFlow({
      confirmModalTitle: 'Deactivate Facility',
      confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
      confirmModalBtnText: 'Deactivate Facility',
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        deactivateFacilityModal.showLoadingModal();
        deactivateFacility({ url: changeStatusBulkURL, success: deactivateSuccess, error: deactivateFailure });
        function deactivateFacility({ url, success, error }) {
          $.ajax({
            url: url,
            data: {
              cadIds: cadId
            },
            dataType: "JSON",
            type: 'POST',
            success: success,
            error: error
          });
        }
        function deactivateSuccess() {
          deactivateFacilityModal.showSuccessModal();
          setTimeout(function () {
            location.reload();
          }, 3000);
        }
        function deactivateFailure() {
          setTimeout(function () {
            deactivateFacilityModal.hideAllModals();
          }, 6000);
        }
      }
    });
    deactivateFacilityModal.init();
    deactivateFacilityModal.showConfirmModal();
  }

  $('body').on('click', '.supply-tab-active', function (e) {
    if (shallAllowClick(this)) {
      let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
      let parent = $(".dropdown-parent-" + pIndex).parents('tr');
      let row = $(".data-table-component").dataTable().api().row(parent);
      let facilities = row.data();
      facId = `${facilities.cadFacId}`;
      facName = `${facilities.cadLocationName}`;
      getFacilitiesUomConfig(facilitiesUomConfig, facId); //Need to get facility UOM config first since retailer config can override default facility UOM config later
      populateSupplychainConfigurationModal(facilities);

      showOrganizationSelectModal();

      $(function () {
        $("#fedex-account").click(function () {
          if ($(this).is(':checked')) {
            $("#fedexAcntChecked").show();
          } else {
            $("#fedexAcntChecked").hide();
          }
        });
      });

    }
  });

  $(function () {
    $("#returns-center").click(function () {
      if ($(this).is(':checked')) {
        if ($("#fedex-account").is(":checked")) {
          $("#fedex-account1").show();
          $("#fedexAcntChecked").show();
        }
        else {
          $("#fedex-account1").show();
        }
      } else {
        $("#fedex-account1").hide();
        $("#fedexAcntChecked").hide();
      }
      $("#fedex-account").click(function () {
        if ($(this).is(':checked')) {
          $("#fedexAcntChecked").show();
        } else {
          $("#fedexAcntChecked").hide();
        }
      });
    });
  });

  let facName = "";
  let facId = "";
  generateModals(facName);

  function generateModals(facName) {
    selectFromOrgModal = $(render(sharedModalHtml, {
      title: 'Configure Supply Chain Facility',
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn save-changes-btn">Save Changes</a>',
      body: render(require("./html/supplyChainConfigModal.html"), {
        facilityName: facName,
        link: orderProcessGuideURL,
        rmsFedexAccounts: getRenderedFedexAccounts(retailerFedexAccounts)
      }),
      topCloseBtn: true,
      autoHideTop: true,
      modalDialogClass: "q-modal-dialog-800"
    }));
    $('body').append(selectFromOrgModal);
  }


  function getRenderedFedexAccounts(retailerFedexAccountsList) {
    const retailerFacilityHtml = '<option value="{%- retailerFedexAccountsListVal.cmtId %}">{%- retailerFedexAccountsListVal.cmtAccountNo %}</option>';
    const response = _.map(retailerFedexAccountsList, (retailerFedexAccountsListVal) => {
      return render(retailerFacilityHtml, {
        retailerFedexAccountsListVal: retailerFedexAccountsListVal
      });
    });
    return response.join("");
  }

  function uncheckAllCheckboxes() {
    $('#fulfillment-center').prop('checked', false);
    $('#distribution-center').prop('checked', false);
    $('#returns-center').prop('checked', false);
    $('#international-fulfillment-center').prop('checked', false);
    $("#additional-units-of-measure").prop('checked', false);

  }

  function populateSupplychainConfigurationModal(data) {
    let retailerAccountNumber = "";
    let retailerHubId = "";
    let retailerCadCmtId = "";

    uncheckAllCheckboxes();
    $(".facName").text(data.cadLocationName);
    $(".facId").text(data.cadFacId);
    $.each(data.cmrAddressAttributes, function (i, attribute) {
      if (attribute.caaValue == 'FC') {
        $('#fulfillment-center').prop('checked', true);
      }
      if (attribute.caaValue == 'DC') {
        $('#distribution-center').prop('checked', true);
      }
      if (attribute.caaValue == 'RC') {
        $('#returns-center').prop('checked', true);

        for (let j = 0; j < retailerFedexAccounts.length; j++) {
          if (data.cadCmtId == retailerFedexAccounts[j].cmtId) {
            retailerAccountNumber = retailerFedexAccounts[j].fdxAccountNo;
          retailerHubId = retailerFedexAccounts[j].cmtHubId;
          retailerCadCmtId = retailerFedexAccounts[j].cmtId;
          }
        }

        
        if (retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != "" && $('#returns-center').is(':checked')) {
          $("#fedex-account1").show();
          $('#fedex-account').attr('checked', true);
        }
        if ($('#fedex-account').is(':checked') && retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != "") {
          $("#fedexAcntChecked").show();
          $("#fedex-account-numbers").val(retailerCadCmtId).trigger("change");
        }
      } else {

        if ($('#returns-center').is(':checked')) {
          $("#fedex-account1").show();
        }
        if ($('#fedex-account1').is(':checked')) {
          $("#fedexAcntChecked").show();
        }
      }
      if (attribute.caaValue == 'IN') {
        $('#international-fulfillment-center').prop('checked', true);
      }
      if (attribute.caaValue == 'UOM') {
        $("#additional-units-of-measure").prop('checked', true);
      }
    })
  }

  function showOrganizationSelectModal() {
    selectFromOrgModal.modal('show');
  }

  function hideOrganizationSelectModal() {
    selectFromOrgModal.modal('hide');
  }

  $(document).on('click','.save-changes-btn', saveSupplyChainConfig);

    function saveSupplyChainConfig(e) {
    e.preventDefault();
    hideOrganizationSelectModal();
    let submitModal = new SubmitModalFlow();
    submitModal.init();
    submitModal.showLoadingModal();
    $.ajax({
      url: supplyChainConfigURL,
      data: {
        facId: facId,
        fulfillmentCenter: $("#fulfillment-center").is(":checked"),
        distributionCenter: $("#distribution-center").is(":checked"),
        internationalFulfillmentCenter: $("#international-fulfillment-center").is(":checked"),
        returnsCenter: $("#returns-center").is(":checked"),
        additionalUnitsOfMeasure: $("#additional-units-of-measure").is(":checked"),
        cmtId: getFedexAccountNumber($("#fedex-account-numbers").val(), $("#returns-center").is(":checked"), $("#fedex-account").is(":checked"))
      },
      dataType: "JSON",
      type: 'POST',
      success: function (data) {
        if (data.success == "Success") {
          submitModal.showSuccessModal();
          setTimeout(function () {
            location.href = pageRefreshUrl;
          }, 3000);
        }
        else {
          submitModal.showFailureModal();
          setTimeout(function () {
            location.href = pageRefreshUrl;
          }, 3000);
        }
      }
    });

  }

  function getFedexAccountNumber(fedexAccountValue, returnsCenterFlag, fedexAccountFlag) {
    if (returnsCenterFlag && fedexAccountValue != null && fedexAccountFlag) {
      return fedexAccountValue;
    } else {
      return "";
    }
  }

  function generateOrganizationActiveCheckErrorModals() {
    organizationActiveCheckErrorModal = $(render(sharedModalHtml, {
      title: 'Activate Facility Error',
      footerBtns: '<a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Okay</a>',
      body: "<div class=q-pad-all-xl>This facility is inactive due to it's organization being in an inactive status. In order to activate this facility you must first reactivate it's organization.</div>",
      topCloseBtn: true,
      autoHideTop: true,
      modalDialogClass: "q-modal-dialog-800"
    }));

    $('body').append(organizationActiveCheckErrorModal);
  }

  function showOrganizationActiveErrorModal() {
    organizationActiveCheckErrorModal.modal('show');
  }

  function shallAllowClick(currentObj) {
    return !($(currentObj).hasClass("disabled"));
  }

  function getFacilitiesUomConfig(data, facId) {
    _.each(data, function (facConfig) {
      if (facConfig.facId == facId) {
        if (facConfig.facUomEditable == 1) {
          $("#additional-units-of-measure").prop('disabled', false);
        } else {
          $("#additional-units-of-measure").prop('disabled', true);
        }

      }

    })

  }

});



// WEBPACK FOOTER //
// ./src/pages/facilities/lookup.js